import React from "react";

import { Control } from "react-hook-form";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Checkbox from "../../pages/Shop/components/Checkbox";
import ReactHookInput from "../forms/ReactHookInput";
import Button from "../NewForms/Button";

export const StyledButton = styled(Button)`
    display: block;
    margin: 5px auto 0 auto;

    @media (min-width: 768px) {
        margin-left: auto;
        margin-right: 0;
    }
`;

export const checkboxStyle = css`
    margin-top: 5px;
`;

const defaultCheckboxChildren = (
    <>
        Ich akzeptiere die&nbsp;
        <a
            href="/datenschutz"
            target="_blank"
            css={css`
                text-decoration: underline;
            `}
        >
            Datenschutzerklärung
        </a>
    </>
);

interface MessageFieldConfig {
    placeholder?: string;
    required?: boolean;
    maxLength?: number;
}

interface FormFooterFieldValues {
    message?: string;
    isPrivacyPolicyAccepted: boolean;
}

interface FormFooterProps<TFieldValues extends FormFooterFieldValues> {
    control: Control<TFieldValues>;
    /** data-gtag value passed to the submit button. */
    gtag: string;
    submitLabel?: string;
    /** Pass `false` for forms that don't collect a free-text message. */
    message?: MessageFieldConfig | false;
    checkboxPlaceholder?: string;
    checkboxChildren?: React.ReactNode;
}

const FormFooter = <TFieldValues extends FormFooterFieldValues>({
    control,
    gtag,
    submitLabel = "Nachricht senden",
    message = {},
    checkboxPlaceholder = "Datenschutzerklärung",
    checkboxChildren = defaultCheckboxChildren,
}: FormFooterProps<TFieldValues>) => {
    // ReactHookInput/Checkbox are themselves generic over the field-values shape;
    // TS can't resolve their Path<fvs> conditional type against an abstract
    // TFieldValues, so we narrow to the concrete shape we actually rely on here.
    const baseControl = control as unknown as Control<
        Required<FormFooterFieldValues>
    >;

    return (
        <>
            {message !== false && (
                <ReactHookInput
                    name="message"
                    type="textarea"
                    fullWidth
                    placeholder={
                        message.placeholder ?? "Deine Nachricht (Pflichtfeld)"
                    }
                    rules={{
                        required: message.required ?? true,
                        ...(message.maxLength
                            ? { maxLength: message.maxLength }
                            : {}),
                    }}
                    control={baseControl}
                />
            )}

            <Checkbox
                css={checkboxStyle}
                name="isPrivacyPolicyAccepted"
                control={baseControl}
                placeholder={checkboxPlaceholder}
                rules={{ required: true }}
            >
                {checkboxChildren}
            </Checkbox>

            <StyledButton data-gtag={gtag}>{submitLabel}</StyledButton>
        </>
    );
};

export default FormFooter;
